import { ReactNode, createContext, useContext } from "react";
import { useFilterCardSeries } from "./filter-card-series.hook";

const FilterCardSeriesContext = createContext(
  {} as ReturnType<typeof useFilterCardSeries>
);
export function useFilterCardSeriesContext() {
  return useContext(FilterCardSeriesContext);
}

interface FilterCardSeriesProviderProps {
  children: ReactNode;
}
export function FilterCardSeriesProvider({
  children,
}: FilterCardSeriesProviderProps) {
  return (
    <FilterCardSeriesContext.Provider value={useFilterCardSeries()}>
      {children}
    </FilterCardSeriesContext.Provider>
  );
}